import * as React from 'react'

import { Box, Spinner } from '@factorialco/deprecated-design-system'

import { observer } from 'mobx-react'

import { useCurrentSession } from 'modules/core/hooks/useCurrentSession'

import { MyGroupedExpensesDataCollection } from 'modules/expenses/components/my_groups/expenses/DataCollection/MyGroupedExpensesDataCollection'
import { useExpensesListPage } from 'modules/expenses/hooks/useExpensesListPage'
import { Group } from 'modules/expenses/hooks/useGroup'

export interface ListProps {
  group: Group
}

const ExpensesList = ({ group }: React.PropsWithChildren<ListProps>) => {
  const { company } = useCurrentSession()

  const { canSeeTransactions, hasExpensesReportOnBehalfFeature, loading } = useExpensesListPage({
    companyId: company.id,
    skipProjectsQuery: true,
  })

  if (loading) {
    return (
      <Box paddingY="s32" paddingX="s48" justifyContent="center" alignItems="center" width="full">
        <Spinner />
      </Box>
    )
  }

  return (
    <MyGroupedExpensesDataCollection
      group={group}
      companyId={company.id}
      canSeeTransactions={canSeeTransactions}
      hasReportOnBehalfFeature={hasExpensesReportOnBehalfFeature}
    />
  )
}

export default observer(ExpensesList)
